export default __webpack_public_path__ + "assets/494fe380eb7360077dad8ed7cf43c9d5.png";